import { type PointerEvent, type ReactNode } from 'react'
import { AevocamTooltip } from './AevocamTooltip'

type Props = {
  tooltip: ReactNode
  onClick: () => void
  disabled?: boolean
  className?: string
  children: ReactNode
}

export function AevocamActionButton({
  tooltip,
  onClick,
  disabled,
  className,
  children,
}: Props) {
  return (
    <AevocamTooltip label={tooltip}>
      <button
        type='button'
        disabled={disabled}
        className={className}
        onPointerDown={onLeftMouseDown(onClick)}
      >
        {children}
      </button>
    </AevocamTooltip>
  )
}

//--------------------------------------------------------------------------------
/**
 * Better way of handling left mouse down events. Avoids lost clicks resulting
 * from rapid re-rendering.
 */
function onLeftMouseDown(handler: () => void) {
  return (e: PointerEvent<HTMLButtonElement>) => {
    if (e.button !== 0) return
    handler()
  }
}
